/* OIDC default Redirect URIs constant*/
export const DEFAULT_REDIRECT_URI_TYPE = 0;
export const DEFAULT_REDIRECT_URIS = [
  {
    "redirectUri": "",
    "redirectUriType": DEFAULT_REDIRECT_URI_TYPE
  }
]

/* Fixed by EAM IdP Admin Service for the POC; never sent */
export const FIXED_OIDC_SCOPE = "openid profile";

/* EAM IdP Admin Service error codes */
export const SBA_APP_NAME_ALREADY_IN_USE = "SBA_APP_NAME_ALREADY_IN_USE";
export const OIDC_CLIENT_ID_ALREADY_IN_USE = "OIDC_CLIENT_ID_ALREADY_IN_USE";
export const OIDC_CLIENT_ID_OR_CLIENT_SECRET_IS_NOT_VALID = "OIDC_CLIENT_ID_OR_CLIENT_SECRET_IS_NOT_VALID";
export const REQUEST_INSUFFICIENT_DATA = "REQUEST_INSUFFICIENT_DATA";
export const CLOUD_SERVER_FAILURE = "CLOUD_SERVER_FAILURE";
